export default "__VITE_ASSET__DjXZrUrR__"